<section
  [class]="data().theme | lowercase"
  [ngClass]="{ 'with-title': data().title }"
  [style.background-color]="style().backgroundColor | color: 'RED'"
  class="row center-xs center-lg">
  <div class="col-lg-12 col-xs-12">
    <div class="container">
      @if (title()) {
        <app-title [titles]="[title()!]" class="title" />
      }
      @if (data().text; as text) {
        <p [innerHTML]="text" [style.color]="style().textColor | color: 'WHITE'"></p>
      }
      @if (data().cta; as cta) {
        <app-button
          [icon]="style().cta.icon"
          [label]="cta.label"
          [size]="style().cta.size"
          [theme]="style().cta.theme"
          [url]="cta.url"
          class="button" />
      }
    </div>
  </div>
</section>
